import { render, staticRenderFns } from "./www-deepmedical-com-cn.vue?vue&type=template&id=7e4908a4&scoped=true&"
var script = {}
import style0 from "./www-deepmedical-com-cn.vue?vue&type=style&index=0&id=7e4908a4&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7e4908a4",
  null
  
)

export default component.exports